import { ServiceGroup } from './../../../../../service-groups/service-group.model';
import { BaseSelectItem } from './../../../../../core/select-drawer/base-select-item.interface';
import { SelectDrawerComponent } from './../../../../../core/select-drawer/select-drawer.component';
import { Component, Input, ViewChild, OnChanges, OnDestroy, OnInit, SimpleChanges, ElementRef } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { User } from '../../../../../core/shared-models/user.model';
import { Subscription } from 'rxjs';
import { UtilsService } from '../../../../../core/utils/utils.service';
import { DataRecordingSetting } from 'src/app/service-groups/service-group.model';

import { MAT_DATE_FORMATS } from '@angular/material/core';
// import { NgxMaterialTimepickerComponent } from 'ngx-material-timepicker';

// Depending on whether rollup is used, moment needs to be imported differently.
// Since Moment.js doesn't have a default export, we normally need to import using the `* as`
// syntax. However, rollup creates a synthetic default module and we thus need to import it using
// the `default as` syntax.
import _moment from 'moment/moment';
// eslint-disable-next-line no-duplicate-imports
import { default as _rollupMoment } from 'moment';

const moment = _rollupMoment || _moment;

@Component({
    selector: 'app-job-form-data',
    templateUrl: './job-form-data.component.html',
    styleUrls: ['./job-form-data.component.scss'],
    providers: [
        {
            // See the Moment.js docs for the meaning of these formats:
            // https://momentjs.com/docs/#/displaying/format/
            provide: MAT_DATE_FORMATS,
            useValue: {
                // parse: {
                // 	dateInput: "LL",
                // },
                display: {
                    dateInput: 'DD.MM.YYYY HH:mm',
                    monthYearLabel: 'MMM YYYY',
                    dateA11yLabel: 'LL',
                    monthYearA11yLabel: 'MMMM YYYY',
                },
            },
        },
    ],
})
export class JobFormDataComponent implements OnInit, OnDestroy {
    @ViewChild('selectWorkerDrawer') selectDrawer: SelectDrawerComponent;

    @Input() jobForm: UntypedFormGroup;
    @Input() changesAllowed = false;
    @Input() asDialog = false;
    @Input() set serviceGroup(sg: ServiceGroup) {
        this._serviceGroup = sg;

        this.updateVisibleFields();
    }
    get serviceGroup() {
        return this._serviceGroup;
    }
    @Input() possibleWorkers: Array<User> = [];

    serviceGroupSubscription: Subscription;

    mobileViewActive = false;
    hideCodeField = false;
    scanEnabled = false;
    scanModalVisible = false;

    workerItems: Array<BaseSelectItem> = [];
    get workerDrawerValue(): BaseSelectItem {
        let w = this.jobForm.get('worker').value as string;
        let preselectedVal = this.possibleWorkers.find((p) => p.firstName + ' ' + p.lastName == w);

        if (preselectedVal) {
            preselectedVal['name'] = preselectedVal.firstName + ' ' + preselectedVal.lastName;
            return preselectedVal as any;
        } else {
            return {
                _id: '-1',
                name: w,
                type: 'user',
            };
        }
    }
    set workerDrawerValue(val: BaseSelectItem) {
        this.jobForm.get('worker').setValue(val ? val.name : val);
    }

    private _serviceGroup: ServiceGroup;

    constructor(public utils: UtilsService) {}

    ngOnInit() {
        this.mobileViewActive = this.utils.mobileViewActive;
    }

    ngOnDestroy() {
        if (this.serviceGroupSubscription) this.serviceGroupSubscription.unsubscribe();
    }

    maybeToggleWorkerDrawer() {
        if (this.changesAllowed) {
            // create a fitting value array
            this.workerItems = this.possibleWorkers.map((w) => {
                w['name'] = w.firstName + ' ' + w.lastName;
                return w as unknown;
            }) as Array<BaseSelectItem>;

            this.selectDrawer.toggleDrawer();
        }
    }

    onMobileSelectItemChanged(item: BaseSelectItem) {
        this.workerDrawerValue = item;
    }

    private updateVisibleFields() {
        if (this.serviceGroup.settings.dataRecording.codeRecording == DataRecordingSetting.Disabled) {
            this.hideCodeField = true;
        } else {
            this.hideCodeField = false;
        }
    }

    /**
     * Triggered when the job date gets changed in sub component
     * @param changeEvent
     */
    onJobDateChanged(changeEvent: { timestamp: number; finalChange: boolean }) {
        this.jobForm.get('date').setValue(changeEvent.timestamp);
    }

    toggleScan(event) {
        event.stopPropagation();
        event.preventDefault();
        this.scanModalVisible = !this.scanModalVisible;
    }

    onScanFieldCodeResult(scanResult: string) {
        this.jobForm.get('code').setValue(scanResult);
        this.scanModalVisible = false;
    }
}
